;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockHeroSplit from './BlockHeroSplit';

const query = /* GraphQL */ `
    ${ctaFragment}
    ${linkFragment}
    ${assetFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockHeroSplit(preview: $preview, id: $id) {
            __typename
            anchorId
            influencerImage {
                ...Asset
            }
            locationStatus {
                ... on ContentTypeLocation {
                    hours
                    timezone
                    temporaryClosed
                }
            }
            removeMorningStar
            headline {
                json
            }
            eyebrow

            description {
                json
            }
            svgLockup {
                ...Asset
            }
            svgLockupSeoText
            cta {
                ... on Cta {
                    ...CTA
                }
            }
            customHex
            customTextHex
            image {
                ...Asset
            }
            imageLarge {
                ...Asset
            }
            imageOnLeft
            imagesCollection(limit: 6) {
                items {
                    ...Asset
                }
            }
            imageVerticalAlignment
            icon
            videoTextureMp4 {
                ...Asset
            }
            videoTextureWebm {
                ...Asset
            }
            videoTexturePoster {
                ...Asset
            }
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockHeroSplit },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockHeroSplit;
}

const BlockHeroSplitServer = async ({ id, ...props }) => {
    const block = await fetchBlock(id);
    const images = block?.imagesCollection?.items;
    return <BlockHeroSplit {...block} images={images} {...props} />;
};

export default BlockHeroSplitServer;
